import React from 'react';
import GrowthImage from 'assets/growth.jpeg';

export const AccelerateGrowth = () => {
  return (
    <section className="w-full bg-white py-12 px-6 md:px-16 flex flex-col md:flex-row items-center justify-between md:my-40">
      <div className="w-full md:w-1/2 flex justify-center md:justify-start">
        <img src={GrowthImage} alt="Seed of Success" className="max-w-xs sm:max-w-sm" />
      </div>

      <div className="w-full md:w-1/2 text-center md:text-left mb-10 md:mb-0">
        <h2 className="text-3xl sm:text-4xl font-bold text-green-700 mb-6">
          ACCELERATE YOUR GROWTH
        </h2>
        <p className="text-gray-700 text-lg leading-relaxed">
          Our acceleration and advisory programs, Ascent and Fast Track Accelerator build upon
          previous training and give later stage entrepreneurs access to mentorship and advisory
          services from industry experts.
        </p>
      </div>
    </section>
  );
};
